<template>
  <article class="layout-section__container">
    <h3 class="layout-section__heading -spacing">Office</h3>

    <ul class="grid-icon">
      <li class="grid-icon__item">
        <svg-icon id="tech-macbook" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-briefcase" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-ping-pong" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-cloud" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-cursor" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-design" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-batterie" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-paper" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-id-card" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="tech-microphone" />
      </li>
    </ul>
  </article>
</template>

<script>
export default {
  name: 'WorkIconsTech'
}
</script>
